import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
  forwardRef,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AppService } from "@root/app.service";
// import { IntlTimeFormat } from '@root/config';
import { DateService } from "@root/shared/service/date.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { padStart } from "@root/util/date";
import { range } from "lodash";

interface TimeOption extends Option {
  rawValue: number;
}

export const TIME_PICKER_PANEL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WidgetTimePickerPanelComponent),
  multi: true,
};

@Component({
  selector: "host-widget-time-picker-panel",
  templateUrl: "./time-picker-panel.component.html",
  styleUrls: ["./time-picker-panel.component.scss"],
  providers: [TIME_PICKER_PANEL_VALUE_ACCESSOR],
})
export class WidgetTimePickerPanelComponent implements OnInit, ControlValueAccessor {
  @ViewChild("hourListElement", { static: false }) hourListElement: ElementRef;
  @ViewChild("minuteListElement", { static: false }) minuteListElement: ElementRef;
  @Output() onCancel = new EventEmitter();
  @Output() onConfirm = new EventEmitter();
  @Input() optionsOfHour;
  optionsOfMinute: TimeOption[] = range(0, 60).map((i) => ({
    label: padStart(i),
    value: padStart(i),
    rawValue: i,
  }));
  open = false;
  _value: string; // 初始值
  // value: string;
  hourStr: string;
  minuteStr: string;

  get hourOpt() {
    return this.optionsOfHour.find((opt) => opt.value === this.hourStr);
  }

  get minuteOpt() {
    return this.optionsOfMinute.find((opt) => opt.value === this.minuteStr);
  }

  get isInternational() {
    return this.app.app.international;
  }

  _registerOnChange: (value: string) => void = (_: any) => {};
  constructor(
    private dateSrv: DateService,
    private t: TranslateService,
    private ngZone: NgZone,
    private app: AppService,
  ) {}

  ngOnInit() {}

  registerOnChange(fn: any): void {
    this._registerOnChange = fn;
  }

  registerOnTouched(fn: any): void {}

  writeValue(value: string): void {
    // this.value = value;
    // this._value = value;
    console.log("value", value);
    if (value) {
      const parts = value.split(":");
      this.hourStr = parts[0];
      this.minuteStr = parts[1];
    } else {
      this.hourStr = "";
      this.minuteStr = "";
    }
  }

  onSelectHour(hour: TimeOption) {
    this.hourStr = hour.value;

    if (!this.minuteStr) {
      this.minuteStr = "00";
    }
  }

  onSelectMinute(minute: TimeOption) {
    this.minuteStr = minute.value;

    if (!this.hourStr) {
      this.hourStr = "00";
    }
  }

  onValueChange(value: string) {
    console.log("value change: ", value);
  }

  onClickCancel() {
    console.log("on cancel");
    this.onCancel.emit();
    // this.open = false;
    // this.value = this._value;
  }

  onClickConfirm() {
    this.onConfirm.emit();
    // this.value = value;
    // this.open = false;

    const value = `${this.hourStr}:${this.minuteStr}`;
    this._registerOnChange(value);
  }

  onVisibleChange(open: boolean) {
    if (open) {
      setTimeout(() => {
        this.ngZone.runOutsideAngular(() => {
          this.scrollToSelected(this.hourListElement.nativeElement, this.hourOpt?.rawValue);
          this.scrollToSelected(this.minuteListElement.nativeElement, this.minuteOpt?.rawValue);
        });
      }, 500);
    }
  }

  private scrollToSelected(instance: HTMLElement, index: number) {
    if (!instance) {
      return;
    }

    const currentOpt = instance.children[index] as HTMLElement;
    instance.scrollTop = currentOpt?.offsetTop;
  }
}
